import heimdallr from '@heimdallr-sdk/browser'
import history from '@heimdallr-sdk/history'
// import console from "@heimdallr-sdk/console";
import xhr from '@heimdallr-sdk/xhr'
import dom from '@heimdallr-sdk/dom'
heimdallr({
  dsn: {
    host: 'https://weixin.flybank.tech',
    init: '/website/project/init',
    upload: '/website/client/upload'
  },
  app: {
    app_id: 'sft'
  },
  plugins: [
    history,
    // console(),
    xhr(),
    dom()
  ],
  userIdentify: {
    name: '__state__.a.0.user.id', // window.__state__ = { a: [{ user: { id:'123' } }] }
    position: 'global'
  }
})
